import { roleTable } from '@digitale-verhuurders-verklaring/rds/src/schema/role.sql';
import { createSelectSchema } from 'drizzle-zod';
import { z } from 'zod';

export const roleSchema = createSelectSchema(roleTable);

export const roleInsertSchema = roleSchema.pick({
  name: true,
});

export type Role = z.infer<typeof roleSchema>;
export type RoleInsert = z.infer<typeof roleInsertSchema>;
